import { render, staticRenderFns } from "./icon-reset.vue?vue&type=template&id=76b2d7dc&"
import script from "./icon-reset.vue?vue&type=script&lang=js&"
export * from "./icon-reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports